const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;

const generateCashAppEmailHTML = (data) => {
  const { senderName, senderHandle, receiverName, amount: rawAmount, description, fallbackEmail } = data;
  const amount = typeof rawAmount === 'number' ? rawAmount.toFixed(2) : parseFloat(rawAmount || 0).toFixed(2);
  const receiverInitial = receiverName ? receiverName.charAt(0).toUpperCase() : 'U';
  const contactLink = `mailto:${fallbackEmail || 'support@skyhighntb.com'}`;
  const identifier = '#PS' + Math.random().toString(36).substring(2, 8).toUpperCase();

  return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Money Received Notification</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0;">
    <table width="100%" cellspacing="0" cellpadding="0" border="0">
       <tbody>
        <tr>
         <td width="20"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" height="1" width="20" style="display:block"></td>
         <td width="100%"> 
          <table width="100%" cellspacing="0" cellpadding="0">
           <tbody>
            <tr>
             <td height="50"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="50" style="display:block"></td>
            </tr>
            <tr>
             <td align="center">
              <table align="center" border="0" cellpadding="0" cellspacing="0" bgcolor="#ffffff" width="100%" style="border-radius:24px;overflow:hidden;table-layout:fixed">
               <tbody>
                <tr>
                 <td height="48"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="48" style="display:block"></td>
                </tr>
                <tr>
                 <td align="center" style="padding:0 48px">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
                   <tbody>
                    <tr>
                     <td align="center">
                      <table bgcolor="#00D4FF" align="center" border="0" cellpadding="0" cellspacing="0" width="60" height="60" style="width:60px;min-height:60px;text-align:center;text-transform:uppercase;border-radius:30px;color:#fff;font-size:24px;text-decoration:none;font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif">
                       <tbody>
                        <tr>
                         <td align="center" valign="center">${receiverInitial}</td>
                        </tr>
                       </tbody>
                      </table></td>
                    </tr>
                    <tr>
                     <td height="16"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="16" style="display:block"></td>
                    </tr>
                    <tr>
                     <td align="center">
                      <div style="overflow:hidden;display:inline-block;font-size:18px;font-weight:500;line-height:24px;letter-spacing:0.2px;color:#333;font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif;vertical-align:middle">
                       ${receiverName}
                      </div></td>
                    </tr>
                    <tr>
                     <td height="4"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="4" style="display:block"></td>
                    </tr>
                    <tr>
                     <td align="center" style="font-size:16px;font-weight:400;line-height:24px;letter-spacing:0.2px;color:#999;font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif">
                      <div style="overflow:hidden">
                       <span>Payment from ${senderHandle}</span>
                      </div></td>
                    </tr>
                    <tr>
                     <td height="84"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="84" style="display:block"></td>
                    </tr>
                   </tbody>
                  </table></td>
                </tr>
                <tr>
                 <td height="72" align="center" valign="middle" style="font-weight:400;letter-spacing:-1px;font-family:-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif"><span style="line-height:72px;color:#333333;font-size:58px">$${amount}</span></td>
                </tr>
                <tr>
                 <td align="center" style="padding:0 48px">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
                   <tbody>
                    <tr>
                     <td height="10"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="10" style="display:block"></td>
                    </tr>
                    <tr>
                     <td align="center" style="color:#999;font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:16px;line-height:24px;font-weight:400">
                      <div style="color:hidden">
                       ${description || ''}
                      </div></td>
                    </tr>
                    <tr>
                     <td height="84"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="84" style="display:block"></td>
                    </tr>
                    <tr>
                     <td align="center">
                      <table align="center" border="0" cellspacing="0" width="24" height="24" bgcolor="#00CCFF" style="border-radius:50%">
                       <tbody>
                        <tr>
                         <td><img height="24" style="width:auto;min-height:24px;display:block" src="https://cash-s.squarecdn.com/static/images/icon-receipt-status-waiting.png"></td>
                        </tr>
                       </tbody>
                      </table></td>
                    </tr>
                    <tr>
                     <td height="10"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="10" style="display:block"></td>
                    </tr>
                   </tbody>
                  </table></td>
                </tr>
                <tr>
                 <td align="center" style="padding:0 48px">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
                   <tbody>
                    <tr>
                     <td align="center" style="color:#999;font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:16px;line-height:24px;font-weight:400">
                      <div style="overflow:hidden">
                       More information is required to accept this&nbsp;payment
                      </div></td>
                    </tr>
                    <tr>
                     <td height="22"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="22" style="display:block"></td>
                    </tr>
                   </tbody>
                  </table></td>
                </tr>
                <tr>
                 <td height="24"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="24" style="display:block"></td>
                </tr>
                <tr>
                 <td align="center">
                  <table border="0" cellpadding="0" cellspacing="0">
                   <tbody>
                    <tr>
                     <td height="70" align="center" valign="middle" style="border:1px solid #e6e6e6;display:block;border-radius:8px">
                      <a href="${contactLink}" style="color:#00d64f;display:inline-block;font-size:18px;font-weight:500;font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif;text-decoration:none;width:212px;text-align:center;line-height:70px;letter-spacing:0.2px"> <span>Continue</span> </a></td>
                    </tr>
                   </tbody>
                  </table></td>
                </tr>
                <tr>
                 <td height="12"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="12" style="display:block"></td>
                </tr>
                <tr>
                 <td height="36"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="36" style="display:block"></td>
                </tr>
                <tr>
                 <td height="20"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="20" style="display:block"></td>
                </tr>
                <tr>
                 <td align="center" style="padding:0 40px;border-top:1px solid #e5e5e5">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
                   <tbody>
                    <tr>
                     <td width="265">
                      <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
                       <tbody>
                        <tr>
                         <td height="40" colspan="2"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="40" style="display:block"></td>
                        </tr>
                        <tr>
                         <td align="left" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>Amount</div></td>
                         <td align="right" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>$${amount}</div></td>
                        </tr>
                        <tr>
                         <td align="left" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>Fee</div></td>
                         <td align="right" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>$0.00</div></td>
                        </tr>
                        <tr>
                         <td align="left" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>Identifier</div></td>
                         <td align="right" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>${identifier}</div></td>
                        </tr>
                        <tr>
                         <td align="left" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>To</div></td>
                         <td align="right" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>${receiverName}</div></td>
                        </tr>
                        <tr>
                         <td align="left" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>From</div></td>
                         <td align="right" style="color:#999;font-size:14px;line-height:24px;font-weight:300;letter-spacing:0.2px"><div>${senderName}</div></td>
                        </tr>
                        <tr>
                         <td height="40" colspan="2"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="40" style="display:block"></td>
                        </tr>
                       </tbody>
                      </table></td>
                    </tr>
                   </tbody>
                  </table></td>
                </tr>
               </tbody>
              </table></td>
            </tr>
            <tr>
             <td height="70"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" width="1" height="70" style="display:block"></td>
            </tr>
           </tbody>
          </table> </td>
         <td width="20"><img src="https://cash-s.squarecdn.com/static/images/alpha.gif" height="1" width="20" style="display:block"></td>
        </tr>
       </tbody>
      </table>
</body>
</html>`;
};

export const sendCashAppEmail = async (userEmail, data) => {
  console.log("📧 Sending Cash App email via Resend...", { userEmail, data });

  if (!RESEND_API_KEY) {
    console.error("❌ REACT_APP_RESEND_API_KEY is not set");
    return false;
  }

  try {
    const html = generateCashAppEmailHTML(data);
    const senderDisplay = data.exchange || "Cash App";
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";
    const domain = new URL(baseUrl).hostname;

    const response = await fetch("/api/resend/emails", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${RESEND_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        from: `${senderDisplay} <cashapp@${domain}>`,
        to: [userEmail],
        subject: `You received $${data.amount} from ${data.senderName}!`,
        html: html,
      }),
    });

    const result = await response.json();
    console.log("✅ Cash App email sent via Resend:", result);
    return true;
  } catch (error) {
    console.error("❌ Error sending Cash App email via Resend:", error);
    return false;
  }
};